import React, { useState } from 'react';
import { Package, Tag, Layers, Box, Barcode, FolderTree, Cpu, Ruler, Info } from 'lucide-react';
import ProductReviews from '@/components/products/ProductReviews';
import { categoryLabel } from '@/utils/categories';

export default function ProductTabs({ product }) {
  const [activeTab, setActiveTab] = useState(0);
  const TABS = ['AUTRES INFOS', 'DESCRIPTION DÉTAILLÉE', 'AVIS CLIENTS'];

  const autresInfos = [
    { label: 'Marque', value: product.brand, icon: Tag },
    { label: 'Référence magasin', value: product.reference, icon: Package },
    { label: 'Référence fournisseur', value: product.reference_fournisseur, icon: Box },
    { label: 'Code EAN', value: product.ean, icon: Barcode },
    { label: 'Catégorie', value: categoryLabel(product.category), icon: FolderTree },
    { label: 'Système', value: product.systeme, icon: Cpu },
    { label: 'Échelle', value: product.scale, icon: Ruler },
    { label: 'Autres', value: product.autres, icon: Info },
  ].filter(item => item.value);

  return (
    <div className="mt-12">
      {/* Tab navigation */}
      <div className="border-b border-gray-200">
        <div className="flex gap-8">
          {TABS.map((tab, i) => (
            <button
              key={i}
              onClick={() => setActiveTab(i)}
              className={`pb-3 pt-1 text-xs font-bold tracking-wide transition-colors relative ${
                activeTab === i ? 'text-gray-900' : 'text-gray-400 hover:text-gray-600'
              }`}
            >
              {tab}
              {activeTab === i && (
                <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-cs-blue rounded-full" />
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Tab content */}
      <div className="border border-gray-200 rounded-lg p-6 mt-0 bg-white">
        {activeTab === 0 && (
          <div>
            {autresInfos.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
                {autresInfos.map((item, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-lg bg-gray-50 flex items-center justify-center shrink-0">
                      <item.icon className="w-4 h-4 text-cs-blue" strokeWidth={1.5} />
                    </div>
                    <div>
                      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">{item.label}</p>
                      <p className="text-sm font-medium text-gray-800">{item.value}</p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-sm text-gray-400">Aucune information complémentaire pour ce produit.</p>
            )}
          </div>
        )}

        {activeTab === 1 && (
          <div>
            {product.long_description ? (
              <p className="text-sm text-gray-700 leading-relaxed whitespace-pre-line">
                {product.long_description}
              </p>
            ) : product.description ? (
              <p className="text-sm text-gray-700 leading-relaxed whitespace-pre-line">
                {product.description}
              </p>
            ) : (
              <p className="text-sm text-gray-400">Aucune description détaillée pour ce produit.</p>
            )}
          </div>
        )}

        {activeTab === 2 && (
          <ProductReviews productId={product.id} productName={product.name} />
        )}
      </div>
    </div>
  );
}